import { useCallback, useMemo } from "react";
import { usePostRequest } from "../ApiWrappers/usePostRequest"
import { Config } from "src/Utils/ConfigService/LoadConfig";
import { logger } from "src/Utils/LoggerService/LoggerService";

export enum LicenseType{
    AuraAppLicenses = "UserLicense",
    CloudStorageLicenses = "StorageLicense",
    AuraSoftwareSuiteLicenses = "AuraSoftwareSuiteLicense"
}

export enum AddLicenseType{
    Demo = "Demo",
    Trial = "Trial"
}

interface IAddNewClinicLicense{
    clinicId:string,
    licenseType:string
    userSeats?: number
}

interface IAddNewPartnerLicense{
    distributorId:string,
    licenseType:string
    userSeats?: number
}

export const useDistributorLicenseService = () => {
    const baseUrl = useMemo(() => Config.GetConfigData().serviceUrl,[]);
    const {postRequest, reqestError, reqestLoading, reqestResponse} = usePostRequest();

    const assignLicenseToPartner = useCallback((entitlementId: string[], distributorId:string) => {
        const requestUrl = `${baseUrl}api/v1/distributor/${distributorId}/assign-license`;
        logger.logInformation(`Request to assign license for entitlement id ${entitlementId} to partner ${distributorId} was made`)
        let req:string[] = entitlementId;
        postRequest<string[]>(req,requestUrl)
    },[baseUrl, postRequest]) 


    const unassignLicenseFromPartner = useCallback((entitlementId: string, distributorId:string) => {
        const requestUrl = `${baseUrl}api/v1/distributor/${distributorId}/remove-license`;
        logger.logInformation(`Request to unassign license for entitlement id ${entitlementId} from partner ${distributorId} was made`)
        postRequest<string>(entitlementId,requestUrl)
    },[baseUrl, postRequest])

    const addLicenseToClinic = useCallback((licenseType: AddLicenseType, clinicId: string, seatCount:number) => {
        const requestUrl = `${baseUrl}api/v1/aura-support/clinic/license`;
        logger.logInformation(`Request to add license for license type ${licenseType}`);
        let req: IAddNewClinicLicense = {
            clinicId: clinicId,
            licenseType: licenseType,
            userSeats: seatCount
        }
        postRequest<IAddNewClinicLicense>(req, requestUrl);
    }, [baseUrl, postRequest])


    const addLicenseToPartner = useCallback((licenseType: AddLicenseType, distributorId: string, seatCount: number) => {
        const requestUrl = `${baseUrl}api/v1/aura-support/distributor/license`;
        logger.logInformation(`Request to add license for license type ${licenseType}`);
        let req: IAddNewPartnerLicense = {
            distributorId: distributorId,
            licenseType: licenseType,
            userSeats: seatCount
        }
        postRequest<IAddNewPartnerLicense>(req, requestUrl);
    }, [baseUrl, postRequest])

    return { assignLicenseToPartner, unassignLicenseFromPartner, addLicenseToClinic,addLicenseToPartner, reqestResponse, reqestLoading, reqestError };
}